// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__scJR6","teamAvatar":"Avatar_teamAvatar__WoV_H"};